import { render, staticRenderFns } from "./IssueItemPc.vue?vue&type=template&id=10de3ad0&scoped=true&"
import script from "./IssueItemPc.vue?vue&type=script&lang=ts&"
export * from "./IssueItemPc.vue?vue&type=script&lang=ts&"
import style0 from "./IssueItemPc.vue?vue&type=style&index=0&id=10de3ad0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10de3ad0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VCard,VCardTitle,VIcon,VImg,VToolbar})
